module.exports = __webpack_public_path__ + "media/images/gallery/constellations/andromeda/and_pn-9ecd2fb978c2b3b39979804a280c8386.gif";